import actions from './actions';

const {
  LOGIN_BEGIN,
  LOGIN_SUCCESS,
  LOGIN_ERR,
  LOGIN_DATA,
  LOGOUT_BEGIN,
  LOGOUT_SUCCESS,
  LOGOUT_ERR,
  RESET_BEGIN,
  RESET_ERR,
  RESET_SUCCESS,
  FORGOT_BEGIN,
  FORGOT_ERR,
  FORGOT_SUCCESS,
  REFRESH_BEGIN,
  REFRESH_ERR,
  REFRESH_SUCCESS,
} = actions;

const initState = {
  login: localStorage.getItem('logedIn'),
  loginData: {},
  loading: false,
  error: null,
  forgotLoading: false,
  forgotErr: {},
  forgotRes: {},
  refreshing: false,
  refreshData: {},
  refreshError: false,
};

/**
 *
 * @todo impure state mutation/explaination
 */
const AuthReducer = (state = initState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case LOGIN_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        login: data,
        loading: false,
      };
    case LOGIN_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case LOGIN_DATA:
      return {
        ...state,
        loginData: data,
      };
    case LOGOUT_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case LOGOUT_SUCCESS:
      return {
        ...state,
        login: data,
        loading: false,
      };
    case LOGOUT_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case RESET_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case RESET_SUCCESS:
      return {
        ...state,
        error: null,
        loading: false,
      };
    case RESET_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case FORGOT_BEGIN:
      return {
        ...state,
        forgotLoading: true,
      };
    case FORGOT_SUCCESS:
      return {
        ...state,
        forgotErr: null,
        forgotLoading: false,
      };
    case FORGOT_ERR:
      return {
        ...state,
        forgotErr: err,
        forgotLoading: false,
      };
    case REFRESH_BEGIN:
      return {
        ...state,
        refreshing: true,
        refreshData: {},
        refreshError: false,
      };
    case REFRESH_SUCCESS:
      return {
        ...state,
        refreshing: false,
        refreshData: data,
        refreshError: false,
      };
    case REFRESH_ERR:
      return {
        ...state,
        refreshing: false,
        refreshData: {},
        refreshError: true,
      };
    default:
      return state;
  }
};
export default AuthReducer;
